module.exports = __webpack_public_path__ + "media/images/flags/SI-5baf6dc55714990fde1f5d52155276c5.svg";